import { getCometh4337Wallet } from '$services/cometh/getComethWallet';
import { getMetriAddress } from '$utils/getMetriAddress';
import { stateWalletOwners } from '$states/walletOwners.svelte';
import { getContract } from 'viem';
import { publicClient } from '$utils/publicClient';
import { AbiSafe } from '$lib/constants/abis';
import type { ExtendedEnrichedOwner } from '$lib/states/walletOwners.svelte';

export const getWalletOwners = async (): Promise<ExtendedEnrichedOwner[]> => {
  const yourOwnAddress = getMetriAddress() ?? localStorage.getItem('safeAddress');

  const { smartAccountClient } = await getCometh4337Wallet(yourOwnAddress);

  const walletOwners = await smartAccountClient.getEnrichedOwners();

  const enrichedWalletOwners: ExtendedEnrichedOwner[] = await Promise.all(
    walletOwners.map(async (owner) => {
      if (owner.isSmartContract) {
        const isGnosisSafeWallet = await isGnosisSafe(owner.address);
        return {
          ...owner,
          isGnosisSafe: isGnosisSafeWallet,
        };
      }
      return {
        ...owner,
        isGnosisSafe: false,
      };
    }),
  );

  stateWalletOwners.set(enrichedWalletOwners);

  return enrichedWalletOwners;
};

export async function isGnosisSafe(address: string): Promise<boolean> {
  try {
    const bytecode = await publicClient.getBytecode({ address: address as `0x${string}` });
    if (!bytecode) return false; // not a contract

    const contract = getContract({
      address: address as `0x${string}`,
      abi: AbiSafe,
      client: publicClient,
    });

    await Promise.all([contract.read.VERSION(), contract.read.getOwners()]);

    return true;
  } catch (_) {
    return false;
  }
}
